import Terms from '@/components/terms';

const TermsPrint = () => {
  return <Terms />;
};

export default TermsPrint;
